import { createContext, type ReactNode, useContext } from 'react';

export type PaymentSource =
  | { type: 'order'; orderId: string; token: string }
  | { type: 'id'; id: string };

const PaymentSourceContext = createContext<PaymentSource | undefined>(
  undefined,
);

export const PaymentSourceProvider = ({
  source,
  children,
}: {
  source: PaymentSource;
  children: ReactNode;
}) => (
  <PaymentSourceContext.Provider value={source}>
    {children}
  </PaymentSourceContext.Provider>
);

export const usePaymentSource = () => useContext(PaymentSourceContext);
